import type { StyleProperties } from '@webbuilder/style-engine'

/**
 * Funde un parche de estilos sobre otros: una cadena vacía borra la
 * propiedad. La misma regla que el editor (`mergeStylePatch` en `appUtils`),
 * aquí para que los looks y los estilos de diseño se apliquen igual en el
 * editor y en el worker.
 */
export function mergeStylePatch(base: StyleProperties | undefined, patch: Partial<StyleProperties>): StyleProperties {
  const next = { ...(base ?? {}) }
  for (const key of Object.keys(patch) as (keyof StyleProperties)[]) {
    if (patch[key] === '') delete next[key]
    else next[key] = patch[key] as string
  }
  return next
}
